import { render, staticRenderFns } from "./MyScans.vue?vue&type=template&id=6a1bb83d&"
import script from "./MyScans.vue?vue&type=script&lang=js&"
export * from "./MyScans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports